const routes = {
  ROOT: "/",
  CHAT: "/chat",
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOTPASSWORD: "/forgotpassword",
  EMAIL_VERIFY: "/account-activate",
  RESET_PASSWORD: "/reset-password",
  FILES: "/chatbot",
  TRAINING: "/training",
  FILEUPLOAD: "/files",
  HTMLDETAILS: "/html-details",
  QUERYDETAILS:"/query-details",
  QUERYDETAILSCHAT:"/query-details/:sessionId",
  CUSTOMCHATBOT: '/custom-bot',
  CUSTOMCHATBOTGO: '/custom-bot-go',
  CUSTOMCHATBOTENVIGO: '/custom-bot-envigo',
  CUSTOMCHATBOTCITIUSTECH: '/custom-bot-citiustech',
  BotListing: '/listing',
  LaunchBot: '/launch',
  TrainingBot: '/ai-training',
  Test:"/test",
  WEB_SCRAPPER:"/web-scrapper"
};

Object.freeze(routes);
export default routes;
